import coq from "refractor/coq";
export default coq;